
<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>big-boss Club' s Mega Event </h1>
                </div>
            </div>
        </div>
    </div>
</section>
<section class>
    <div class="section-lg">
        <div class="container">
            <div class="text-justify">
                <p>big-boss Club's Mega Event - a collaborative showcase with GH Raisoni Skill Tech University, Nagpur and GHRCACS, Nagpur, highlighting the latest innovations, student achievements, and technological advancements across the institutions.</p>
            </div>
            <div class="row mb-20 mt-5">
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/big-boss2.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/big-boss2.avif"
                                alt="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/big-boss3.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/big-boss3.avif"
                                alt="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/big-boss4.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/big-boss4.avif"
                                alt="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/big-boss6.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/big-boss6.avif"
                                alt="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/big-boss7.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/big-boss7.avif"
                                alt="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/big-boss8.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/big-boss8.avif"
                                alt="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/big-boss9.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/big-boss9.avif"
                                alt="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/big-boss10.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/big-boss10.avif"
                                alt="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/big-boss11.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/big-boss11.avif" alt="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>  
                    </a>
                    </div>
                </div>
                
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/big-boss13.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/big-boss13.avif" alt="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>  
                    </a>
                    </div>
                </div>
                
                
            </div>
        </div>
    </div>
</section>